const CUSTOMER_LOG_TYPE = Object.freeze({
    FIRST_OPEN: 1,
    FIRST_LOGIN: 2,
});

const CUSTOMER_LOG_TYPE_TITLE = Object.freeze({
    [CUSTOMER_LOG_TYPE.FIRST_OPEN]: 'Установка',
    [CUSTOMER_LOG_TYPE.FIRST_LOGIN]: 'Авторизация',
});

module.exports = {
    CUSTOMER_LOG_TYPE,
    CUSTOMER_LOG_TYPE_TITLE
};
